import * as React from "react";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import LinearProgress from "@material-ui/core/LinearProgress";
import { ModalImage } from 'src/component/shared/layout/components/ModalImage/ModalImage';
import { MoneyFullBRL } from '../../../services';

import { TablePagination } from "@material-ui/core";

// tslint:disable-next-line:no-empty-interface
export interface IProductTableCortezProps {
    error: string | null;
    loading: boolean;
    modalImage: {
		img: string;
		open: boolean;
	}
    rows?: any[];
    items: Array<{ header: string; row: string }>;
    tableProps: {
        limit: number;
        page: number;
        total: number;
    };
    handleChangePage(ev: any, page: number): void;
    handleChangeRowsPerPage(event: any): void;
    handleModalImage(img: any): void;
}

// tslint:disable-next-line:no-empty-interface
export interface IProductTableCortezState {}

export class ProductTableCortez extends React.Component<
    IProductTableCortezProps,
    IProductTableCortezState
> {
    constructor(props: IProductTableCortezProps) {
        super(props);
    }

    public render() {
        const { error, rows, modalImage, handleChangePage, handleChangeRowsPerPage, handleModalImage, items, loading, tableProps } = this.props;
        const { limit, page, total } = tableProps;
        return (
            <div>
                {loading ? (
                    <LinearProgress />
                ) : (
                    <div>
                        <ModalImage
                            img={modalImage.img}
                            open={modalImage.open}
                            onClose={() => handleModalImage('')}
                        />
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {items.map((v) => (
                                        <TableCell key={this.getKey()}>{v.header}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            {!error && rows && rows.length > 0 && (
                                <TableBody>
                                    {rows.map((row: any, index) => (
                                        <TableRow key={index}>
                                            <TableCell key={0}>
                                                {!!row.imagem && <IconButton
                                                    onClick={() => handleModalImage(row.imagem)}
                                                    style={{padding: '0px'}}
                                                >
                                                    <Visibility />
                                                </IconButton>}
                                            </TableCell>
                                            <TableCell key={1}>{row.sku}</TableCell>
                                            <TableCell key={2}>{row.titulo}</TableCell>
                                            {/* <TableCell key={3}>{row.fabricante}</TableCell> */}
                                            <TableCell key={3}>{row.selo}</TableCell>
                                            <TableCell key={4}>{row.grupo_economico}</TableCell>
                                            <TableCell key={5}>{row.autor}</TableCell>
                                            <TableCell key={6}>{row.bisac}</TableCell>
                                            <TableCell key={7}>{row.categoria}</TableCell>
                                            <TableCell key={8}>{MoneyFullBRL(row.preco_capa)}</TableCell>
                                            <TableCell key={9}>{row.dta_publicacao}</TableCell>
                                            <TableCell key={10}>{row.dta_vencimento}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            )}
                        </Table>
                        <TablePagination
                            component="div"
                            page={page}
                            count={total}
                            rowsPerPage={limit}
                            rowsPerPageOptions={[10,30,50,100]}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page',
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </div>
                )}
            </div>
        );
    }

    private getKey = () => {
        return Math.random()*12;
    }
}


// WEBPACK FOOTER //
// ./src/component/cortez/product-cortez/ProductTableCortez.tsx